import { Col, Row } from 'react-bootstrap';
import sucesionImg from 'assets/img/landing/sucesionjpg.jpg'; // Asegúrate de mover tus imágenes a tu carpeta de assets o usar rutas relativas
import accidenteImg from 'assets/img/landing/6365340.webp';

const OtrasEspecialidades = () => {
  return (
    <section className="py-10 bg-body-tertiary" id="sucesiones">
      <div className="container-small px-lg-7 px-xxl-3">
        <div className="text-center mb-9">
          <h2 className="fs-3 fs-lg-2">También realizamos</h2>
        </div>

        {/* Sección Sucesiones */}
        <Row className="align-items-center g-5 mb-10">
          <Col lg={6}>
            <h3 className="fw-bold mb-3">Sucesiones</h3>
            <p className="text-body-secondary">Entendemos que los procesos de sucesión son momentos delicados y de gran importancia tanto en el ámbito emocional como jurídico. Por ello, ofrecemos un servicio especializado en derecho sucesorio, brindando asesoramiento legal integral para garantizar que el patrimonio de nuestros clientes sea transferido de acuerdo con la ley y con sus deseos.</p>
            <p className="text-body-secondary">Contamos con amplia experiencia en derecho sucesorio para resolver cada caso en particular. Brindamos asesoramiento personalizado, acorde a las necesidades de cada uno de nuestros clientes.</p>
            <p className="text-body-secondary">Nos encargamos de llevar adelante el inicio, seguimiento, impulso y conclusión de la sucesión.</p>
            <a href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" className="btn btn-outline-primary rounded-pill mt-3" target="_blank" rel="noreferrer">Contactanos</a>
          </Col>
          <Col lg={6}>
            <img src={sucesionImg} alt="Sucesiones" className="img-fluid rounded-3 shadow" />
          </Col>
        </Row>

        {/* Sección Accidentes Civiles */}
        <Row className="align-items-center g-5" id="derechocivil">
          <Col lg={6} className="order-1 order-lg-0">
            <img src={accidenteImg} alt="Accidentes Civiles" className="img-fluid rounded-3 shadow" />
          </Col>
          <Col lg={6} className="order-0 order-lg-1">
            <h3 className="fw-bold mb-3">Accidentes civiles</h3>
            <p className="text-body-secondary">Los accidentes civiles pueden generar consecuencias físicas, emocionales y económicas significativas. Por ello, ofrecemos un servicio especializado en la defensa de los derechos de quienes han sufrido daños debido a negligencia, imprudencias o situaciones ajenas a su control.</p>
            <p className="text-body-secondary">Evaluamos su caso de manera integral para determinar las responsabilidades y las acciones legales disponibles y gestionamos la reclamación de compensaciones por daños personales, materiales o morales, asegurando que reciba una indemnización justa.</p>
            <p className="text-body-secondary">Confíe en nuestro equipo para brindarle el apoyo legal necesario durante este proceso. Contáctenos hoy mismo para una consulta gratuita y sin compromiso.</p>
            <a href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" className="btn btn-outline-primary rounded-pill mt-3" target="_blank" rel="noreferrer">Contactanos</a>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default OtrasEspecialidades;